import { createPopper } from '@popperjs/core';

export default function (element) {
    const button = element.querySelector('.calendar-venues__button');
    const popover = element.querySelector('.calendar-venues__select');
    const options = [ ...element.querySelectorAll('input[type="radio"]') ];

    createPopper(button, popover, {
        placement: 'bottom-end',
    });

    const handleKeyDown = event => {
        const enabledOptions = options.filter(option => {
            return !option.disabled;
        });

        let selectedOption = enabledOptions.indexOf(document.activeElement);

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            selectedOption = (selectedOption + 1) % enabledOptions.length;
            enabledOptions[selectedOption].focus();
            enabledOptions[selectedOption].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            selectedOption = (selectedOption - 1 + enabledOptions.length) % enabledOptions.length;
            enabledOptions[selectedOption].focus();
            enabledOptions[selectedOption].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Escape') {
            popover.hidePopover();
            button.focus();
        } else if (event.key === 'Enter') {
            event.preventDefault();
            enabledOptions[selectedOption].checked = true;
            enabledOptions[selectedOption].dispatchEvent(new Event('change', { bubbles: true }));
            popover.hidePopover();
            button.focus();
        }
    }

    popover.addEventListener('beforetoggle', ({ newState }) => {
        if (newState === 'open') {
            button.setAttribute('aria-expanded', 'true');

            const selectedOption = options.find(option => {
                return option.checked;
            });

            const fallbackOption = options.find(option => {
                return !option.disabled;
            });

            popover.addEventListener('keydown', handleKeyDown);

            requestAnimationFrame(() => {
                (selectedOption || fallbackOption)?.focus();
            });
        } else {
            button.setAttribute('aria-expanded', 'false');
            popover.removeEventListener('keydown', handleKeyDown);
        }
    });

    const handleClick = () => {
        popover.hidePopover();
    }

    for (const option of options) {
        option.addEventListener('click', handleClick);
    }
}
